import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const SlashedEye: FC<SvgProps> = ({ size, className, color, stroke }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.98002 8.223C3.04448 9.32718 2.34784 10.6132 1.93402 12C3.22602 16.338 7.24402 19.5 12 19.5C12.993 19.5 13.953 19.362 14.863 19.105M6.22802 6.228C7.94064 5.09781 9.9481 4.49682 12 4.5C16.756 4.5 20.773 7.662 22.065 11.998C21.3569 14.3673 19.837 16.4115 17.772 17.772M6.22802 6.228L3.00002 3M6.22802 6.228L9.87802 9.878M17.772 17.772L21 21M17.772 17.772L14.122 14.122C14.4006 13.8434 14.6216 13.5127 14.7724 13.1486C14.9232 12.7846 15.0008 12.3945 15.0008 12.0005C15.0008 11.6065 14.9232 11.2164 14.7724 10.8524C14.6216 10.4883 14.4006 10.1576 14.122 9.879C13.8434 9.6004 13.5127 9.3794 13.1487 9.22863C12.7847 9.07785 12.3945 9.00025 12.0005 9.00025C11.6065 9.00025 11.2164 9.07785 10.8524 9.22863C10.4884 9.3794 10.1576 9.6004 9.87902 9.879M14.121 14.121L9.88002 9.88"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SlashedEye;
